module.exports = __webpack_public_path__ + "static/media/container_x2.f8fe8bc1.png";